import u from '@/utils'
import store from '@/store/index'
import axios from 'axios'

let state = {
  personalAccessTokens: [],
  userPersonalAccessTokens: [],
  personalAccessTokensRoles: {},
  personalAccessTokensUsers: {},
  userPersonalAccessTokensRoles: {}
}

const getters = {}

const mutations = {
  setPersonalAccessTokens(state, personalAccessTokens) {
    state.personalAccessTokens = personalAccessTokens
  },
  setUserPersonalAccessTokens(state, userPersonalAccessTokens) {
    state.userPersonalAccessTokens = userPersonalAccessTokens
  },
  setPersonalAccessTokensRoles(state, payload) {
    state.personalAccessTokensRoles = {
      ...state.personalAccessTokensRoles,
      [payload.personalAccessTokens.hexId]: payload.honeyRoles
    }
  },
  setPersonalAccessTokensUsers(state, payload) {
    state.personalAccessTokensUsers = {
      ...state.personalAccessTokensUsers,
      [payload.personalAccessTokens.hexId]: payload.honeyUser
    }
  },
  setUserPersonalAccessTokensRoles(state, payload) {
    state.userPersonalAccessTokensRoles = {
      ...state.userPersonalAccessTokensRoles,
      [payload.personalAccessTokens.hexId]: payload.honeyRoles
    }
  },
  updatePersonalAccessToken(state, personalAccessToken) {
    let index = state.personalAccessTokens.findIndex(
      item => item.hexId === personalAccessToken.hexId
    )
    state.personalAccessTokens.splice(index, 1, personalAccessToken)
  }
}

let actions = {
  async fetchPersonalAccessTokens({ commit }) {
    let response = await axios.get('/api/v1/personalAccessTokens')
    if (response.data._embedded) {
      let personalAccessTokens = [
        ...response.data._embedded.personalAccessTokens
      ]
      personalAccessTokens = personalAccessTokens.map(personalAccessToken =>
        u.processResp(personalAccessToken)
      )
      commit('setPersonalAccessTokens', personalAccessTokens)
      return personalAccessTokens
    }
    return null
  },

  async updatePersonalAccessToken({ commit }, { body, hexId }) {
    let response = await axios.patch(
      `/api/v1/personalAccessTokens/${hexId}`,
      body
    )
    response.data = u.processResp(response.data)
    commit('updatePersonalAccessToken', response.data)
    return response.data
  },

  async fetchUserPersonalAccessTokens({ dispatch, commit }) {
    if (!store.state.session.user.id) {
      await dispatch('getUserPrincipal')
    }
    let response = await axios.get(`/api/v1/personalAccessTokens/me`)
    if (response.data._embedded) {
      let personalAccessTokens = [
        ...response.data._embedded.personalAccessTokens
      ]
      personalAccessTokens = personalAccessTokens.map(personalAccessToken =>
        u.processResp(personalAccessToken)
      )
      commit('setUserPersonalAccessTokens', personalAccessTokens)
      return personalAccessTokens
    }

    return null
  },

  async fetchPersonalAccessTokensRoles({ commit }, personalAccessToken) {
    let response = await axios.get(
      `/api/v1/personalAccessTokens/${personalAccessToken.hexId}/honeyRoles`
    )
    let honeyRoles = [...response.data._embedded.honeyRoles]
    commit('setPersonalAccessTokensRoles', { personalAccessToken, honeyRoles })
  },

  async fetchPersonalAccessTokensUsers({ commit }, personalAccessToken) {
    let response = await axios.get(
      `/api/v1/personalAccessTokens/${personalAccessToken.hexId}/honeyUser`
    )
    let honeyUser = response.data.honeyUser
    commit('setPersonalAccessTokensUsers', { personalAccessToken, honeyUser })
  },

  async fetchUserPersonalAccessTokensRoles({ commit }, personalAccessToken) {
    let response = await axios.get(
      `/api/v1/personalAccessTokens/${personalAccessToken.hexId}/honeyRoles`
    )
    let honeyRoles = [...response.data._embedded.honeyRoles]
    commit('setUserPersonalAccessTokensRoles', {
      personalAccessToken,
      honeyRoles
    })
  },

  async deletePersonalAccessToken(context, personalAccessToken) {
    await axios.delete(
      `/api/v1/personalAccessTokens/${personalAccessToken.hexId}`
    )
  },

  async savePersonalAccessToken(context, personalAccessTokenBody) {
    personalAccessTokenBody.honeyRoles.forEach(
      (honeyRole, index, honeyRoles) => {
        honeyRoles[index] = `/api/v1/honeyRoles/${honeyRole.hexId}`
      }
    )
    let response = await axios.post(
      '/api/v1/personalAccessTokens/me',
      personalAccessTokenBody
    )
    return response.data
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
